import {
  FETCH_LOAD_PROJECT_SETTINGS_REQUEST,
  FETCH_LOAD_PROJECT_SETTINGS_SUCCESS,
  FETCH_LOAD_PROJECT_SETTINGS_FALUIRE,
  
} from './loadProjectSettingsTypes'

const initialState = {
  loading: false,
  projectSettingsInformation: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOAD_PROJECT_SETTINGS_REQUEST: return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_PROJECT_SETTINGS_SUCCESS: return {
      ...state,
      projectSettingsInformation: action.payload,
      error: '',
      loading: false,
    }
  
    case FETCH_LOAD_PROJECT_SETTINGS_FALUIRE: return {
      ...state,
      loading: false,
      projectSettingsInformation: null,
      error: action.payload,
    }
    default: return state
  }
}

export default reducer
